import {Controller, useFormContext} from "react-hook-form";
import {SessionGenInfoSessionLinkFormFieldProps} from "./types";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {Input, Space} from "antd";
import {SessionGenInfoFormFields} from "../types";

export function SessionGenInfoSessionLinkFormField({
  id,
  label,
  placeholder,
}: SessionGenInfoSessionLinkFormFieldProps) {
  const {control} = useFormContext<SessionGenInfoFormFields>();

  return (
    <FormField
      id={id}
      label={label}
      renderInput={(id) => (
        <Controller
          control={control}
          name="slug"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space direction="vertical" size={16} style={{display: "flex"}}>
              <Input
                id={id}
                status={error?.message ? "error" : ""}
                onChange={onChange}
                onBlur={onBlur}
                size="large"
                value={value}
                placeholder={placeholder}
                ref={ref}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
